// Toolbar button: pick an .xlsx/.xlsm and store it as the survey-export
// template for a project (step 2) or property (step 3). Once set, the step-4
// export generates server-side from this template.

import { useState } from "react";
import { FileUp, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { uploadExcelTemplate } from "../services/uploadExcelTemplate";

export function UploadTemplateButton({
  kind,
  id,
  label,
}: {
  kind: "project" | "property";
  id: string;
  label: string;
}) {
  const [uploading, setUploading] = useState(false);

  const pick = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".xlsx,.xlsm";
    input.onchange = async (e) => {
      const file = (e.target as HTMLInputElement).files?.[0];
      if (!file) return;
      setUploading(true);
      try {
        await uploadExcelTemplate(file, { kind, id });
        toast.success(`Template "${file.name}" set for this ${kind}.`);
      } catch (err) {
        console.error("[template upload]", err);
        toast.error(`Template upload failed${err instanceof Error ? `: ${err.message}` : ""}`);
      } finally {
        setUploading(false);
      }
    };
    input.click();
  };

  return (
    <button
      onClick={pick}
      disabled={uploading}
      className="flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors disabled:opacity-50"
      title={`Upload the .xlsx/.xlsm export template for this ${kind} — step-4 exports then generate server-side from it`}
    >
      {uploading ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <FileUp className="h-3.5 w-3.5" />}
      {label}
    </button>
  );
}
